import { createAction, props } from '@ngrx/store';

import { AddToCartEvent } from '../../models/events/add-to-cart.model';
import { ClickEvent } from '../../models/events/click.model';
import { ZenitEventData } from '../../models/zenit-general.model';

import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';
import { ViewItemProduct } from '@shared/analytics/COMMON/services/product-view/view-item.service';
import { ProductViewPlace } from '@shared/product/models';

const ZenitActionTypes = {
    ADD_TO_CART_EVENT: '[zenit] ADD_TO_CART_EVENT',
    CLEAR_VIEWED_PRODUCTS: '[zenit] CLEAR_VIEWED_PRODUCTS',
    CLICK_EVENT: '[zenit] CLICK_EVENT',
    IMPRESSIONS_HIT_EVENT: '[zenit] IMPRESSIONS_HIT_EVENT',
    LIST_ITEM_VISIBLE: '[zenit] LIST_ITEM_VISIBLE',
    MARK_REFERRER_SENT: '[zenit] MARK_REFERRER_SENT',
    PAGE_HIT_EVENT: '[zenit] PAGE_HIT_EVENT',
    ZENIT_EVENT_ERROR: '[zenit] ZENIT_EVENT_ERROR',
    ZENIT_EVENT_SUCCESS: '[zenit] ZENIT_EVENT_SUCCESS',
};

export const ZenitPageHitEventAction = createAction(
    ZenitActionTypes.PAGE_HIT_EVENT,
    props<{ eventFrom?: EventFrom; eventData?: ZenitEventData }>()
);

export const ZenitAddToCartEvent = createAction(
    ZenitActionTypes.ADD_TO_CART_EVENT,
    props<{ addToCartEvent: AddToCartEvent }>()
);

export const ZenitClickEvent = createAction(
    ZenitActionTypes.CLICK_EVENT,
    props<{ clickEvent: ClickEvent }>()
);

export const ZenitListItemVisible = createAction(
    ZenitActionTypes.LIST_ITEM_VISIBLE,
    props<{
        eventFrom: EventFrom;
        inviewportElementId: string;
        place: ProductViewPlace;
        product: ViewItemProduct;
        relatedsSectionId: string;
    }>()
);

export const ImpressionsHitEventAction = createAction(
    ZenitActionTypes.IMPRESSIONS_HIT_EVENT,
    props<{
        products: ViewItemProduct[];
        eventFrom: EventFrom;
        relatedsSectionId: string;
        place: ProductViewPlace;
    }>()
);

export const ZenitClearViewedProducts = createAction(
    ZenitActionTypes.CLEAR_VIEWED_PRODUCTS,
);

export const ZenitEventSuccess = <T>() => createAction(
    ZenitActionTypes.ZENIT_EVENT_SUCCESS,
    props<{ eventData: T }>()
);

export const ZenitEventError = createAction(
    ZenitActionTypes.ZENIT_EVENT_ERROR,
    props<{ error: unknown }>()
);

export const MarkReferrerSent = createAction(
    ZenitActionTypes.MARK_REFERRER_SENT
);
